<template>
  <v-menu offset-y v-if="distributorCreatable">
    <template v-slot:activator="{ on, attrs }">
      <round-button icon="add_circle" v-bind="attrs" v-on="on" data-testid="create-account">
        {{ $t('button.add_account') }}
        <span class="ml-1">&#9660;</span>
      </round-button>
    </template>
    <v-list>
      <v-list-item to="/admin/accounts/new">
        <v-list-item-title>{{ $t('menu.account') }}</v-list-item-title>
      </v-list-item>
      <v-list-item to="/admin/accounts/new?type=distributor">
        <v-list-item-title>{{ $t('menu.distributor_account') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <round-button v-else icon="add_circle" to="/admin/accounts/new" data-testid="create-account">
    {{ $t('button.add_account') }}
  </round-button>
</template>

<i18n lang="yaml">
ja:
  button:
    add_account: 'アカウントを追加'

  menu:
    account: 'アカウント'
    distributor_account: '代理店アカウント'

en:
  button:
    add_account: 'Add account'

  menu:
    account: 'Account'
    distributor_account: 'Distributor account'
</i18n>

<script>
import Features from '@/mixins/features';
import RoundButton from '@/components/atoms/RoundButton';

export default {
  name: 'create-account-button',
  mixins: [Features],
  components: {
    RoundButton,
  },
  computed: {
    // 代理店アカウントを作れるのは admin だけ。代理店ログイン時は通常のアカウント作成のみ
    distributorCreatable() {
      return this.$store.getters.getCurrentUser.admin && this.featureIsActive('distributor_account');
    },
  },
};
</script>
